import clsx from 'clsx';
import { PropsWithChildren } from 'react';

type PrevPaginationIcon = {
  className?: string;
};

const NextPagination = ({ className, children }: PropsWithChildren<PrevPaginationIcon>) => {
  return (
    <svg
      className={clsx(className)}
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
    >
      <path d="M8.02548 4.32947L0.503451 8.38405L0.5477 0.202479L8.02548 4.32947Z" fill="white" />
      {children}
    </svg>
  );
};

export default NextPagination;
